import React, { useState } from "react";
import { googleBtnImage } from "../../../assets";
import GoogleLogin from "react-google-login";
import { googleAuthClientID, invokeApi } from "../../../bl_libs/invokeApi";
import { useSockets } from "../../../Context/Context-Sockets/ContextSockets";
import { withRouter } from "react-router-dom";
function GoogleAuth(props) {
  const {
    setOpenPhoneNumberScreen,
    setIsLoading,
    setAuth,
    handleReqPostData,
    reqPostData,
  } = props;
  const { socketON } = useSockets();

  const responseGoogle = (response) => {
    console.log(response, "google response");
    // EmailVarification(response);
    UserSignupWithGoogle(response.tokenId);
  };

  const responseGoogleFailed = (response) => {
    // showErrorSnak("Authentication failed for Google.");
  };

  const EmailVarification = (response) => {
    let requestObj = {
      path: "/app_api/validate_Email",
      method: "POST",
      headers: {},
    };
    let postData = {
      email: response.profileObj.email,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        console.log(res, "email verification");
        if (res.status === 1) {
          UserSignupWithGoogle(response.tokenId);
        } else {
          setOpenPhoneNumberScreen(true);
          setAuth({
            email: response.profileObj.email,
            profile: response.profileObj,
            accessToken: response.tokenId,
            authType: "google",
          });
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    });
  };

  const UserSignupWithGoogle = (accessToken) => {
    let requestObj = {
      path: "/api/customer/login_by_google",
      method: "POST",
      headers: {},
    };
    let postData = {
      access_token: `${accessToken}`,
      phone_number: ``,
    };
    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      if (res.code === 200) {
        localStorage.setItem("token", res.data.auth_token);
        let storage_obj = {
          ...res.data,
          ...res.data.user,
        };

        if (reqPostData) {
          handleReqPostData(res.data.auth_token, storage_obj);
          return;
        }

        localStorage.setItem("user", JSON.stringify(storage_obj));
        props.history.push("/dashboard");
        socketON();
      } else {
        setIsLoading(false);
      }
    });
  };
  return (
    <>
      <GoogleLogin
        clientId={googleAuthClientID}
        render={(renderProps) => (
          <button
            className="facebook-btn-style"
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
          >
            <img src={googleBtnImage} />
          </button>
        )}
        buttonText="Login"
        autoLoad={false}
        disabled={false}
        onSuccess={responseGoogle}
        onFailure={responseGoogleFailed}
        cookiePolicy={"single_host_origin"}
        //
        // responseType="code"
        // accessType="offline"
        // scope="openid email profile https://www.googleapis.com/auth/calender"
      />
    </>
  );
}

export default withRouter(GoogleAuth);
